import { Privacy } from '@/screens/privacy';

export default function PrivacyScreen() {
  return <Privacy />;
}
